import { useState } from "react";
import FormSignIn from "./FormSignIn";
import { Form } from "react-final-form";

export default function EnterPassword({ loading, onSubmit }) {

    const [error, setError] = useState(false)

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);

    const validate = (data) => {
        let errors = {}
        if (!data.password) {
            errors.password = "Contraseña requerida";
        }
        return errors
    }

    const handleSubmit = (data, form) => {
        // form.restart()
        if (onSubmit) onSubmit(data)
    }

    const getFormErrorMessage = (meta) => {
        return (
            isFormFieldValid(meta) && <small className="p-error flex text-left">{meta.error}</small>
        )
    }

    return (
        <Form
            onSubmit={handleSubmit}
            initialValues={{ email: "", password: "" }}
            validate={validate}
            render={({ handleSubmit }) => (
                <FormSignIn
                    type="enter_password"
                    error={error}
                    loading={loading}
                    isFormFieldValid={isFormFieldValid}
                    getFormErrorMessage={getFormErrorMessage}
                    handleSubmit={handleSubmit}
                />
            )}
        />
    )
}